type PropTypes = {
  className?: string
}

const CameraRefocusIcon = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      className={className}
    >
      <path
        fill="currentColor"
        d="M20 9V6.308a.294.294 0 0 0-.096-.212.294.294 0 0 0-.212-.096H17V4.5h2.692c.505 0 .933.175 1.283.525.35.35.525.778.525 1.283V9H20ZM2.5 9V6.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525H7V6H4.308a.294.294 0 0 0-.212.096.294.294 0 0 0-.096.212V9H2.5ZM17 19.5V18h2.692a.294.294 0 0 0 .212-.096.294.294 0 0 0 .096-.212V15h1.5v2.692c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H17Zm-12.692 0c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 0 1-.525-1.283V15H4v2.692c0 .077.032.148.096.212a.294.294 0 0 0 .212.096H7v1.5H4.308Zm2.115-3.923V8.423h11.154v7.154H6.423Zm1.5-1.5h8.154V9.923H7.923v4.154Z"
      />
    </svg>
  )
}

export default CameraRefocusIcon
